import React from "react";

const Badge = ({
  variant = "light",
  color = "primary",
  size = "md",
  startIcon,
  endIcon,
  children,
}) => {
  const baseStyles =
    "inline-flex items-center px-2 py-0.5 justify-center gap-1 rounded-full font-medium";

  // Define size styles — smaller
  const sizeStyles = {
    sm: "text-theme-xs",
    md: "text-xs",
  };

  // Define color styles for variants — dark-only monochrome
  const variants = {
    light: {
      primary:
        "bg-white/10 text-gray-300",
      success:
        "bg-success-500/15 text-success-500",
      error:
        "bg-error-500/15 text-error-500",
      warning:
        "bg-warning-500/15 text-orange-400",
      info: "bg-blue-light-500/15 text-blue-light-500",
      light: "bg-white/5 text-white/80",
      dark: "bg-white/5 text-white",
    },
    solid: {
      primary: "bg-white text-black",
      success: "bg-success-500 text-white",
      error: "bg-error-500 text-white",
      warning: "bg-warning-500 text-white",
      info: "bg-blue-light-500 text-white",
      light: "bg-white/5 text-white/80",
      dark: "bg-gray-700 text-white",
    },
  };

  // Get styles based on size and color variant
  const sizeClass = sizeStyles[size];
  const colorStyles = variants[variant][color];

  return (
    <span className={`${baseStyles} ${sizeClass} ${colorStyles}`}>
      {startIcon && <span className="mr-0.5">{startIcon}</span>}
      {children}
      {endIcon && <span className="ml-0.5">{endIcon}</span>}
    </span>
  );
};

export default Badge;
